export const VOLLEYBALL_PERIODS = {
  S1: 'S1', // Set 1
  S2: 'S2', // Set 2
  S3: 'S3', // Set 3
  S4: 'S4', // Set 4
  S5: 'S5', // Set 5
}